import styled from 'styled-components';

import { white } from 'styles/colors';
import { fromLarge, fromMedium } from 'styleUtils/mediaQueries';

export const SectionWrapper = styled.div`
    position: relative;
    background-color: ${white};
    padding: 1.5rem 0;
    ${fromMedium`
    padding: 3rem 3rem 3rem 0;
  `}
    ${fromLarge`
    max-width: 70%;
    padding: 100px 80px 100px 0;
  `};
`;
